export const questions = [
  {
    id: 1,
    text: "When you're stressed, you're most likely to:",
    options: [
      { text: "Get frustrated and want to fix everything immediately", element: "wood" },
      { text: "Talk it out with friends and seek connection", element: "fire" },
      { text: "Overthink and worry about everyone else", element: "earth" },
      { text: "Feel overwhelmed and want to hide", element: "metal" },
      { text: "Withdraw and need space to process alone", element: "water" }
    ]
  },
  {
    id: 2,
    text: "Your ideal way to spend a free Saturday is:",
    options: [
      { text: "Being active outdoors or tackling a challenging goal", element: "wood" },
      { text: "Hosting friends or going to a social event", element: "fire" },
      { text: "Organizing your home or helping someone with a project", element: "earth" },
      { text: "Pursuing a craft, reading, or enjoying quiet activities", element: "metal" },
      { text: "Something low-key, maybe by water or in nature", element: "water" }
    ]
  },
  {
    id: 3,
    text: "When making decisions, you:",
    options: [
      { text: "Make quick decisions and adapt as you go", element: "wood" },
      { text: "Go with your gut and trust your instincts", element: "fire" },
      { text: "Consider how it affects everyone involved", element: "earth" },
      { text: "Analyze all the details and seek perfection", element: "metal" },
      { text: "Take your time and reflect deeply", element: "water" }
    ]
  },
  {
    id: 4,
    text: "Your biggest challenge tends to be:",
    options: [
      { text: "Slowing down and not getting impatient with obstacles", element: "wood" },
      { text: "Maintaining boundaries and not burning out from overcommitting", element: "fire" },
      { text: "Putting your own needs first instead of always helping others", element: "earth" },
      { text: "Letting go of perfectionism and accepting 'good enough'", element: "metal" },
      { text: "Building confidence and trusting your inner strength", element: "water" }
    ]
  },
  {
    id: 5,
    text: "People often describe you as:",
    options: [
      { text: "Energetic, determined, and a natural leader", element: "wood" },
      { text: "Warm, enthusiastic, and fun to be around", element: "fire" },
      { text: "Caring, reliable, and always there for others", element: "earth" },
      { text: "Thoughtful, precise, and having high standards", element: "metal" },
      { text: "Calm, wise, and deeply intuitive", element: "water" }
    ]
  },
  {
    id: 6,
    text: "When you're out of balance, you might experience:",
    options: [
      { text: "Tension headaches, frustration, or muscle tightness", element: "wood" },
      { text: "Heart palpitations, insomnia, or feeling scattered", element: "fire" },
      { text: "Digestive issues, worry, or feeling stuck in your head", element: "earth" },
      { text: "Respiratory issues, sadness, or feeling disconnected", element: "metal" },
      { text: "Low energy, fear, or back/knee pain", element: "water" }
    ]
  },
  {
    id: 7,
    text: "Your communication style is:",
    options: [
      { text: "Direct, confident, and solution-oriented", element: "wood" },
      { text: "Expressive, animated, and full of stories", element: "fire" },
      { text: "Gentle, supportive, and focused on harmony", element: "earth" },
      { text: "Precise, thoughtful, and well-organized", element: "metal" },
      { text: "Quiet, deep, and sometimes mysterious", element: "water" }
    ]
  },
  {
    id: 8,
    text: "You feel most energized when:",
    options: [
      { text: "Taking action and seeing progress toward goals", element: "wood" },
      { text: "Connecting with others and sharing experiences", element: "fire" },
      { text: "Creating stability and nurturing relationships", element: "earth" },
      { text: "Working on something meaningful with attention to detail", element: "metal" },
      { text: "Having quiet time to recharge and reflect", element: "water" }
    ]
  },
  {
    id: 9,
    text: "Your relationship to change is:",
    options: [
      { text: "You initiate change and push through obstacles", element: "wood" },
      { text: "You love new experiences but sometimes jump in too quickly", element: "fire" },
      { text: "You prefer stability but adapt when others need you to", element: "earth" },
      { text: "You like to plan changes carefully and thoroughly", element: "metal" },
      { text: "You flow with changes but need time to process", element: "water" }
    ]
  },
  {
    id: 10,
    text: "When you need to relax, you're drawn to:",
    options: [
      { text: "Nature, physical activity, or planning new adventures", element: "wood" },
      { text: "Social activities, music, or creative expression", element: "fire" },
      { text: "Comfort food, cozy spaces, or nurturing activities", element: "earth" },
      { text: "Organized spaces, quality materials, or peaceful rituals", element: "metal" },
      { text: "Water, quiet spaces, or gentle movement like yoga", element: "water" }
    ]
  },
  {
    id: 11,
    text: "Your approach to work and productivity is:",
    options: [
      { text: "Goal-oriented, efficient, likes to see quick results", element: "wood" },
      { text: "Collaborative, creative, with bursts of high energy", element: "fire" },
      { text: "Steady, supportive, focused on helping the team", element: "earth" },
      { text: "Methodical, high-quality, with attention to detail", element: "metal" },
      { text: "Deep thinking, innovative, works well independently", element: "water" }
    ]
  },
  {
    id: 12,
    text: "What you most want from acupuncture treatment is:",
    options: [
      { text: "Tension relief, anger management, and help with headaches", element: "wood" },
      { text: "Better sleep and help managing anxiety or overwhelm", element: "fire" },
      { text: "Digestive support and relief from worry or mental loops", element: "earth" },
      { text: "Help with respiratory issues, grief, or feeling disconnected", element: "metal" },
      { text: "More energy, reduced fear, and support for back pain", element: "water" }
    ]
  },
  {
    id: 13,
    text: "Your physical build tends to be:",
    options: [
      { text: "Slender and athletic with strong, wiry muscles", element: "wood" },
      { text: "Fine-boned with expressive features and quick movements", element: "fire" },
      { text: "Rounded or pear-shaped with soft, gentle features", element: "earth" },
      { text: "Square-shaped with strong bones and pale, clear skin", element: "metal" },
      { text: "Large frame with strong bones and darker undertones", element: "water" }
    ]
  },
  {
    id: 14,
    text: "Your skin and hair tend to be:",
    options: [
      { text: "Oily skin, strong nails, thick hair that grows fast", element: "wood" },
      { text: "Easily flushed, quick to sweat, fine or reddish hair", element: "fire" },
      { text: "Soft, moist, smooth skin with lustrous hair", element: "earth" },
      { text: "Dry, clear, cool skin with fine, light-colored hair", element: "metal" },
      { text: "Thick, lustrous hair with cool or clammy skin", element: "water" }
    ]
  }
];
export const elementInfo = {
  wood: {
    name: "Wood",
    icon: "🌳",
    description: "Wood types are natural leaders with strong drive and vision. You're energetic, determined, and like to take action. You thrive on challenges and growth, but may struggle with impatience and frustration when things don't move fast enough."
  },
  fire: {
    name: "Fire",
    icon: "🔥",
    description: "Fire types are warm, enthusiastic, and social. You love connection, joy, and sharing experiences with others. You're naturally charismatic and expressive, but may struggle with boundaries and burning out from overcommitment."
  },
  earth: {
    name: "Earth",
    icon: "🏔️",
    description: "Earth types are nurturing, supportive, and stable. You naturally care for others and create harmony in relationships. You're reliable and thoughtful, but may struggle with overthinking and putting others' needs before your own."
  },
  metal: {
    name: "Metal",
    icon: "⚡",
    description: "Metal types are precise, disciplined, and value quality. You have high standards and appreciate beauty, order, and meaning. You're naturally introspective and thoughtful, but may struggle with perfectionism and sadness."
  },
  water: {
    name: "Water",
    icon: "💧",
    description: "Water types are wise, intuitive, and deeply reflective. You have natural inner strength and prefer to work independently. You're calm and persistent, but may struggle with fear, low energy, and building confidence."
  }
};